
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 143","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip1_1_113)"}},[_c('path',{attrs:{"d":"M50 98.313c15.065 0 27.273-12.002 27.273-26.813V26.812C77.273 12.002 65.065 0 50 0S22.727 12.001 22.727 26.813V71.5c0 14.803 11.96 26.813 27.273 26.813zm43.182-44.688c-3.779 0-6.818 2.989-6.818 6.452V71.5c0 20.48-17.606 36.979-38.722 35.666-18.773-1.164-34.006-18.598-34.006-37.09v-10c0-3.462-3.054-6.451-6.818-6.451S0 56.614 0 60.077v8.98c0 25.04 18.173 47.368 43.182 50.747v9.79H31.818c-5.167 0-9.33 4.239-9.08 9.376.111 2.298 2.205 4.03 4.535 4.03h45.454c2.336 0 4.424-1.736 4.534-4.03.239-5.131-3.909-9.376-9.08-9.376H56.819v-9.432C81.165 116.886 100 96.329 100 71.5V60.077c0-3.463-3.04-6.452-6.818-6.452z","fill":"currentColor"}})])])
          )
        }
      }
    